import { FunctionComponent } from "react";
import { useNavigate } from "react-router";
import { observer } from "mobx-react-lite";

import { RouteConstants } from "../../../models/enums/route-constants.enum";
import { useTermsOfUseService } from "../../../services/ServiceHooks/termsOfUseHook";
import { useStore } from "../../../stores/StoreContext";

import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import { TermsOfUseDialog } from "./TermsOfUseDialog";

interface ITermsOfUseVerificationProps {
  isLoading: boolean;
  termsOfConditionsBase64Document: string | null;
  onAccepted: () => void;
}

const RawTermsOfUseVerification: FunctionComponent<ITermsOfUseVerificationProps> = (
  props: ITermsOfUseVerificationProps,
) => {
  const navigate = useNavigate();
  const { userStore } = useStore();
  const termsOfUseService = useTermsOfUseService();

  const acceptTermsOfUse = async (): Promise<void> => {
    await termsOfUseService.acceptCurrentTermsOfUsePatch();
    userStore.setUserAcceptedTermsOfUseAndPrivacyPolicy(true);
    props.onAccepted();
  };

  const declineTermsOfUse = async (): Promise<void> => {
    userStore.setUserAcceptedTermsOfUseAndPrivacyPolicy(false);
    navigate(`/${RouteConstants.RejectedTermsOfUse}`, { replace: true });
  };

  return (
    <TermsOfUseDialog
      base64PdfDocument={props.termsOfConditionsBase64Document!}
      isLoading={props.isLoading}
      onAccept={acceptTermsOfUse}
      onDecline={declineTermsOfUse}
    />
  );
};

export const TermsOfUseVerification = observer(RawTermsOfUseVerification);
